import React, { useEffect } from 'react'
import Common_Title_1 from '../../common/common_components/common_title_1/Common_Title_1'
import './Real_Wealth.css'
import { useDispatch, useSelector } from 'react-redux';
import { GurujiWisdom } from '../../../features/admin/common/Slice';
import parse from 'html-react-parser';
import { IDS } from '../../../utils/IDS';


const Real_Wealth = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.common.guruji_wisdom);

    useEffect(() => {
        dispatch(GurujiWisdom());
    }, [dispatch])
    return (
        <section className='Real_Wealth'>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-md-5 col-sm-10'>
                        <div className='img_holder'>
                            <img src={`${IDS.IMG_URL + data?.Guruji_wisdom?.image}`} className='baba_img' />
                            {/* <img src='/assets/images/home/real_wealth/img1.png' className='baba_img' /> */}
                        </div>
                    </div>
                    <div className='col-md-7'>
                        <div className='right_div'>
                            <Common_Title_1 titleText={data?.name || " "} subText={data?.subname || " "} />

                            <p className='text1'>{parse(data?.description || " ")} </p>

                            {/* <p className='text2'>Prana that pervades this universe is God. Even in the atoms of our body, the same prana form of God resides.</p> */}

                        </div>
                        {/* <div className='right_div'>
                            <Common_Title_1 titleText="REAL WEALTH " subText="Guruji's Wisdom" />

                            <p className='text1'>इस ब्रह्माण्ड में व्याप्त प्राण ही परमात्मा है। हमारे शरीर के अणु अणु में भी ही प्राण स्वरुप परमात्मा विराजमान है।</p>

                            <p className='text2'>Prana that pervades this universe is God. Even in the atoms of our body, the same prana form of God resides.</p>

                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Real_Wealth
